import React, { Component } from 'react'
import { selectors, actions } from '../sagas/kegs'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IndexHeader from './IndexHeader'
import KegRow from './KegRow'
import NoKegs from './NoKegs'
import { BottomRow } from '../shared/BottomRow'
import { ScrollSync } from 'react-scroll-sync'

class KegsIndex extends Component {
  componentDidMount () {
    this.props.getKegs()
  }

  render () {
    return (
      <div>
        <ScrollSync>
          <div>
            { this.props.kegs && this.props.kegs.length > 0 &&
              <div>
                <IndexHeader />
                { this.props.kegs &&
                  this.props.kegs.map(keg => {
                    return (
                      <KegRow
                        key={keg.id}
                        keg={keg}
                      />
                    )
                  })
                }
                <BottomRow extra_class={'bottom-row-5'}/>
              </div>
            }
          </div>
        </ScrollSync>
      </div>
    )
  }
};

const mapDispatchToProps = (dispatch) => bindActionCreators(actions, dispatch)

const mapStateToProps = (store) => ({
  kegs: selectors.kegs(store),
  loaded: selectors.loaded(store)
})

export default (connect(mapStateToProps, mapDispatchToProps)(KegsIndex))



// WEBPACK FOOTER //
// ./src/Kegs/index.js